// @Version: 1.0.1
import { Injectable } from '@angular/core';
import { IDropDown } from './autocomplete.model';

@Injectable()
export class FieldItemAutocompleteService {

   constructor() { }

   public transformLists (data: IDropDown[]): IDropDown[] {
      let transform: IDropDown[] = []; 
      data.forEach(elem => {
         if (!isNaN(Number(elem.key))) transform.push({key: Number(elem.key), desc: elem.desc});
         else transform.push(elem); 
      })
      return transform; 
   }
}
